import React from 'react';
import cn from 'classname';

function PayoutSortingTH({ className, children, index, sorting, sort, isSortIconVisible = true }) {
	const isActive = index === sorting.index;

	return (
		<th
			className={cn(className, isSortIconVisible && {
				[`new-table__head__item__th__sort-head`]: true,
				[`new-table__head__item__th__sort-head-active`]: isActive,
				[`new-table__head__item__th__sort-${sorting.direction}`]: isActive && !!sorting.direction
			})}
			onClick={() => sort(index)}
		>
			{children}
		</th>
	);
}

export default PayoutSortingTH;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-head/components/payout-sorting-th.js